import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'reactstrap';

import { isActiveSection, links } from '../nav-links';
import { toSnake } from '../../../util/general';
import { currentUserId } from '../../../features/fe-data/selectors';
import getPermissions from '../permissions';

export const DisconnectedPdxNavLink = ({
  children,
  link,
  onMouseEnter,
  onClick,
  text,
  hasPermission,
  isActive,
}) => (
  hasPermission && (
  <NavLink
    id={`${text || toSnake(children.toString())}_panel`}
    href={link}
    onMouseEnter={onMouseEnter}
    onClick={onClick}
    className={isActive ? ' active' : ''}
  >
    {text}
    {children}
  </NavLink>
  )
);

DisconnectedPdxNavLink.defaultProps = {
  link: undefined,
  text: undefined,
  onMouseEnter: undefined,
  onClick: undefined,
  children: undefined,
  hasPermission: true,
  isActive: false
};

DisconnectedPdxNavLink.propTypes = {
  link: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  text: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
  hasPermission: PropTypes.bool,
  isActive: PropTypes.bool
};

export const mapStateToProps = (state, ownProps) => ({
  text: ownProps.id ? links(currentUserId(state))[ownProps.id].text : null,
  hasPermission: ownProps.id ? getPermissions(state)[ownProps.id] : true,
  link: ownProps.id ? links(currentUserId(state))[ownProps.id].link : ownProps.link || '',
  isActive: isActiveSection(ownProps.sectionItems || [], currentUserId(state))
});

export default connect(mapStateToProps)(DisconnectedPdxNavLink);
